import { useOkapiKy } from "@folio/stripes/core";
import { fetchPeriodicalLibraryById } from "../api/periodicalLibraryService";
import { useDetailEntity } from "./useDetailEntity";
export var PERIODICAL_LIBRARY_DETAIL_KEY = "periodical-library-detail";
export var usePeriodicalLibraryActions = function () {
    var kyInstance = useOkapiKy();
    var _a = useDetailEntity(PERIODICAL_LIBRARY_DETAIL_KEY, function (id) {
        return fetchPeriodicalLibraryById(kyInstance, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedItem: selectedItem,
        handleRowClick: function (item) { return handleRowClick(item.id); },
        handleCloseDetail: handleCloseDetail,
    };
};
